import React, { Component, PropTypes } from 'react';
import html2canvas from 'html2canvas';
import LoaderPDF from './LoaderPDF';

const isBrowser = typeof window !== 'undefined' && window !== null;
let JsPDF;

if (isBrowser) {
  // we need to import JsPDF here because some function of this shit is hooked to window in DOM lol
  JsPDF = require('jspdf');

  window.html2canvas = html2canvas;
}

export default class PdfPrinter extends Component {

  componentWillReceiveProps(nextProps) {
    if (
        (nextProps.printSettings.printToPdfStatus !== this.props.printSettings.printToPdfStatus)
        && nextProps.printSettings.printToPdfStatus
      ) {
      this.printDocument();
    }
  }

  printDocument = () => {

    const pixelToMM = 0.264583; // converting pixels to mm
    // const marginLeft = -((window.innerWidth / 2) - (793 / 2)) * pixelToMM;
    const marginTop = ((1122 - window.innerHeight) / 2) * pixelToMM;

    const input = document.getElementById('divToPrint_PDF'); // yeah yeah, I know... but if I did't have to, I would't do it
    html2canvas(input, {
      proxy: 'html2canvasProxy', // we need to use proxy server in node.js because of CORS policy html2canvasProxy is a url path to proxy
      useCORS: true,
    })
    .then((canvas) => {
      const imgData = canvas.toDataURL('image/png');
      let pdf;
      if (this.props.printSettings.printOrientation === 'pionowo') {
        pdf = new JsPDF('p', 'mm', [297, 210]);
        pdf.addImage(imgData, 'JPEG', 0, marginTop);
      } else if (this.props.printSettings.printOrientation === 'poziomo') {
        pdf = new JsPDF('l', 'mm', [297, 210]);
        pdf.addImage(imgData, 'JPEG', 0, 0);
      }
      pdf.save('wydruk_mapy.pdf');
      this.props.changePrintToPdfStatus(false);
      this.props.onMove();
      // this.props.printingTriggered();
    });
  }

  render() {
    return (
      <div>
        {/* <div className="mb5">
          <button onClick={() => this.printDocument()}>Print</button>
        </div>
        <div>Note: Here the dimensions of div are same as A4</div>
        <div>You Can add any component here</div> */}
        <div
          id="divToPrint_PDF"
          className="mt4"
          style={{
            backgroundColor: '#f5f5f5',
          }}
        >
          {this.props.children}
        </div>
        { this.props.printSettings.printToPdfStatus ?
          <LoaderPDF />
        : null }
      </div>
    );
  }
}

PdfPrinter.propTypes = {
  changePrintToPdfStatus: PropTypes.func,
  onMove: PropTypes.func,
  printSettings: PropTypes.object,
  children: PropTypes.element,
};



// WEBPACK FOOTER //
// src/components/PdfPrinter/PdfPrinter.js